import { Layout } from 'antd';
import { Navigate } from 'react-router-dom';
import React from 'react';
import { selectIsAdminAuth } from 'modules/Admin/slice/selectors';
import { useSelector } from 'react-redux';

export default function AdminPrivateRoute(props) {
  const isAdminAuth = useSelector(selectIsAdminAuth);

  return !isAdminAuth ? (
    <Navigate replace to="/admin/auth" />
  ) : (
    <Layout
      style={{
        height: 'calc(100vh)',
      }}
    >
      {props.children}
    </Layout>
  );
}
